module.exports = __webpack_public_path__ + "static/ec-5d6fdbf808b19221f220ae2e0e991017.svg";